import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const THANK_YOU = "Thank you — that really helped 💜";

export const ThankButton = ({ noteId, index, done, onDone, name, hearted, label = "Say thank you 💜" }) => {
  const [busy, setBusy] = useState(false);
  if (done) return (
    <span className="text-[11px] text-mm-primary font-semibold" data-testid={`thanked-${noteId}-${index}`}>
      💜 Thanked{hearted && <span data-testid={`thanks-hearted-${noteId}-${index}`}> · {name} sent a heart back</span>}
    </span>
  );
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/supporter-notes/${noteId}/thank`, { index });
      toast.success(`Thanks sent to ${name}`);
      onDone(data);
    } catch (e) { toast.error(errMsg(e, "Could not send thanks")); } finally { setBusy(false); }
  };
  return (
    <button onClick={send} disabled={busy} className="mm-chip !py-1 !px-2.5 !text-[11px] inline-flex items-center gap-1" data-testid={`thank-${noteId}-${index}`}>
      {busy && <Loader2 size={11} className="animate-spin" />} {label}
    </button>
  );
};
